export const annotationTypes = [
  "features",
  "warnings",
  "assemblyPieces",
  "lineageAnnotations",
  "parts",
  "cutsites",
  "orfs",
  "translations",
  "primers",
  "guides",
  "restriction_sites"
];
export const modifiableTypes = [
  "features",
  "assemblyPieces",
  "lineageAnnotations",
  "warnings",
  "parts",
  "translations",
  "primers",
  "guides",
  "restriction_sites"
];
